/*** IMPORTS FROM imports-loader ***/
(function() {

define(['jquery', 'pip-events'],
    function ($, pipEvents) {

        var breakpoint = {
            list: ['Small', 'Medium', 'Large', 'ExtraLarge'],
            previous: null,
            current: null
        };

        // Way to avoid re-declaration?  Build-time step?
        var breakpoints = {
            Small: 576,
            Medium: 768,
            Large: 992,
            ExtraLarge: 1200
        }

        function getCurrentBreakpoint() {
            return window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
        }

        function triggerBreakpointForJavascript() {
            breakpoint.current = getCurrentBreakpoint();
            if (breakpoint.previous !== breakpoint.current) {
                pipEvents['resizeTo' + breakpoint.current].trigger();
            }
            breakpoint.previous = breakpoint.current;
        }

        function init() {
            $(window).off('resize.breakpoints');
            $(window).on('resize.breakpoints', triggerBreakpointForJavascript);
        }

        return {
            breakpoints: breakpoints,
            init: init,
            getCurrentBreakpoint: getCurrentBreakpoint,
            isActiveBreakpointEqualToOrLargerThan: function (size) {
                return breakpoint.list.indexOf(getCurrentBreakpoint()) >= breakpoint.list.indexOf(size);
            },
            isActiveBreakpointEqualToOrSmallerThan: function (size) {
                return breakpoint.list.indexOf(getCurrentBreakpoint()) <= breakpoint.list.indexOf(size);
            }
        }
    });

}.call(window));